export default __webpack_public_path__ + "static/media/icon-average-rating.2c9ce5f1.svg";